export default function ErrorMsgTemplate(data) {
    //language=HTML
    return `
        <div id="${data.msgNum}" class="msgTemp d-flex justify-content-between align-items-center border-bottom mb-4 n-text-right">
            <p>${data.msg}</p>
            <div class="btnsContainer d-flex flex-nowrap">
                <a role="button" id="showErrorOriginalMsg" title='${data.translateId("showOriginalMsg")}' class=" pr-2 text-secondary"><i
                        class="fa-solid fa-circle-exclamation fa-1-5x"></i></a>
                <a role="button" id="showErrorMsgHelp" title='${data.translateId("showHelpMessage")}' class=" pr-2 text-secondary"><i
                        class="fa-solid fa-circle-question fa-1-5x"></i></a>
            </div>
        </div>`;
}